import { render, staticRenderFns } from "./listaSediAlpi.vue?vue&type=template&id=efee1680"
import script from "./listaSediAlpi.vue?vue&type=script&lang=js"
export * from "./listaSediAlpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports